var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from "react";
import { listItemId, } from "@costar-search-x/core";
import { CustomToast } from "../components";
import { useMounted } from "./use-mounted";
export var useExcludeWithToast = function (excludeItem, excludeSelected, excludeUnselected, message, data, toast) {
    var _a = useState([]), deletingItems = _a[0], setDeletingItems = _a[1];
    var isMounted = useMounted();
    var sendToastMessage = useCallback(function (count) {
        toast.closeAll();
        var customToast = React.createElement(CustomToast, { toastMsg: message({ count: count }), marginTop: "0" });
        isMounted.current &&
            toast({
                position: "center-center",
                duration: 3000,
                render: function () { return customToast; },
            });
    }, [isMounted, message, toast]);
    var removeItem = useCallback(function (itemId) {
        function _removeItem() {
            return __awaiter(this, void 0, void 0, function () {
                var items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            //Start fading the row for this item that we are deleting.
                            setDeletingItems(function (previous) { return __spreadArray(__spreadArray([], previous, true), [itemId], false); });
                            return [4 /*yield*/, (excludeItem === null || excludeItem === void 0 ? void 0 : excludeItem(itemId))];
                        case 1:
                            items = _a.sent();
                            //Open the toast message
                            sendToastMessage((items === null || items === void 0 ? void 0 : items.length) || 0);
                            return [2 /*return*/];
                    }
                });
            });
        }
        //Return the promise so that the calling context can await for the action to be complete.
        return _removeItem();
    }, [excludeItem, sendToastMessage]);
    //Once the item has finally been removed, we can clear the state.
    useEffect(function () {
        if (!data) {
            setDeletingItems(function (previous) { return (previous.length > 0 ? [] : previous); });
        }
        else {
            //This map should not be executed on every render. But given that `data` does not change until the new search results are loaded, this map only gets executed once per new search result.
            var itemsInGrid_1 = data.map(function (item) { return item[listItemId]; });
            setDeletingItems(function (previous) {
                var newList = previous.filter(function (item) { return itemsInGrid_1.includes(item); });
                return newList.length !== previous.length ? newList : previous;
            });
        }
    }, [data]);
    var removeSelectedItems = useCallback(function () {
        function _removeSelectedItem() {
            return __awaiter(this, void 0, void 0, function () {
                var items_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!excludeSelected) return [3 /*break*/, 2];
                            return [4 /*yield*/, excludeSelected()];
                        case 1:
                            items_1 = _a.sent();
                            if (items_1) {
                                setDeletingItems(function (previous) { return __spreadArray(__spreadArray([], previous, true), items_1, true); });
                                //Open the toast message
                                sendToastMessage(items_1.length || 0);
                            }
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        //Return the promise so that the calling context can await for the action to be complete.
        return _removeSelectedItem();
    }, [excludeSelected, sendToastMessage]);
    var removeUnselectedItems = useCallback(function () {
        //TODO: implement fading transition here
        function _removeUnselectedItems() {
            return __awaiter(this, void 0, void 0, function () {
                var items_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!excludeUnselected) return [3 /*break*/, 2];
                            return [4 /*yield*/, excludeUnselected()];
                        case 1:
                            items_2 = _a.sent();
                            if (items_2) {
                                setDeletingItems(function (previous) { return __spreadArray(__spreadArray([], previous, true), items_2, true); });
                                //Open the toast message
                                sendToastMessage(items_2.length || 0);
                            }
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        //Return the promise so that the calling context can await for the action to be complete.
        return _removeUnselectedItems();
    }, [excludeUnselected, sendToastMessage]);
    var onRemoveItem = useCallback(function (i) {
        if (excludeItem) {
            return removeItem(i);
        }
        return Promise.resolve();
    }, [excludeItem, removeItem]);
    return {
        removeItem: onRemoveItem,
        removeSelectedItems: removeSelectedItems,
        removeUnselectedItems: removeUnselectedItems,
        deletingItems: deletingItems,
    };
};
//# sourceMappingURL=use-exclude-with-toast.js.map